import { render, staticRenderFns } from "./ViewUserProfile.vue?vue&type=template&id=ddcb0c08"
import script from "./ViewUserProfile.vue?vue&type=script&lang=js"
export * from "./ViewUserProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports